





















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'EditDrawerContent',  
  props: {
    title:String,
    value:Boolean,
    dirty:Boolean,
    saving:Boolean,
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  }
})
export default class EditDrawerContent extends Vue {
  title!:string
  value!:boolean
  dirty!:boolean
  saving!:boolean
  width!:string

  get showDrawer(){
    return this.value
  }
  set showDrawer(value) {    
    this.$emit('input', value)
  }
  
  saveData() {
    this.$emit("save")   
  }  

}
